// JsFromRoutes CacheKey 94c1dc3d75be9ee01f5ea1671de9026a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/.well-known/nuabase/token'),
}
